/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import FileIcon, { defaultStyles } from 'react-file-icon';
import ReactTooltip from 'react-tooltip';
import i18next from 'i18next';

import linkIcon from '../../assets/linkIcon.svg';

import style from './styles.module.scss';

interface ImageItem {
  type: 'Image';
  order: number;
  original: string;
  thumbnail: string;
  filename?: string;
}

interface DocumentItem {
  type: 'Document';
  order: number;
  file: string;
  fileUrl: string;
  name?: string;
}

interface LinkItem {
  type: 'Link';
  order: number;
  link: string;
  title: string;
}

interface Props {
  items: (ImageItem | DocumentItem | LinkItem)[];
}

interface State {}

class Gallery extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderDocument(doc: DocumentItem) {
    const extension = doc.file.split('.').pop() || '';
    const title = doc.name ? doc.name : decodeURIComponent(doc.file.split('/').pop() || '');

    return (
      <>
        <a
          href={doc.fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={style.rowElement}
          data-tip={title}
          download
        >
          <FileIcon extension={extension} {...defaultStyles[extension]} className={style.icon} />
          <div className={style.description}>
            <h2 className="title-medium text-ellipsis">{doc.name}</h2>
          </div>
        </a>
        <ReactTooltip />
      </>
    );
  }

  renderImage(img: ImageItem) {
    return (
      <>
        <a
          href={img.original}
          target="_blank"
          data-tip={img.filename}
          style={{
            background: `url(${img.thumbnail})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            paddingBottom: '20px'
          }}
        />
        <ReactTooltip />
      </>
    );
  }

  renderLink(link: LinkItem) {
    const url = link.link.includes('https') ? link.link : `https://${link.link}`;
    return (
      <>
        <a href={url} target="_blank" className={style.rowElement} data-tip={url}>
          <img src={linkIcon} className={style.icon} />
          <div className={style.description}>
            <h2 className="title-medium text-ellipsis">{link.title}</h2>
            <p className="text-ellipsis">{link.link}</p>
          </div>
        </a>
        <ReactTooltip />
      </>
    );
  }

  render() {
    const items = this.props.items.sort((a, b) => b.order - a.order).reverse();
    const documents: DocumentItem[] = [];
    const images: ImageItem[] = [];
    const links: LinkItem[] = [];
    items.forEach(item => {
      switch (item.type) {
        case 'Document':
          documents.push(item);
          break;
        case 'Image':
          images.push(item);
          break;
        default:
          links.push(item);
          break;
      }
    });

    return (
      <>
          { documents.length > 0 ?
            <div className="m-bottom-5">
              <h2 className="title-medium m-bottom-3">{i18next.t('projectDetail:documents')}</h2>
              <div>{documents.length > 0 && documents.map(this.renderDocument)}</div>
            </div>
              : <></> }
          { images.length > 0 ?
          <div className="m-bottom-5">
              <h2 className="title-medium m-bottom-3">{i18next.t('projectDetail:images')}</h2>
              <div className={style.gallery}>{images.length > 0 && images.map(this.renderImage)}</div>
            </div>
              : <></> }
          { links.length > 0 ?
            <div className="m-bottom-5">
              <h2 className="title-medium m-bottom-3">{i18next.t('projectDetail:links')}</h2>
              <div>{links.length > 0 && links.map(this.renderLink)}</div>
            </div>
              : <></> }
      </>
    );
  }
}

export default Gallery;
